<template>
  <v-row>
    <v-col v-show="warningShown" cols="12" class="pt-0 mt-0 caption">
      <span class="text--disabled"><strong>Warning:</strong> This application is still a work-in-progress and is subject to change or data loss. Until there is an official way to back up your session, please be aware that you could lose your progress due to an update or by clearing certain browser settings on your device.</span>
       <v-btn @click="warningShown = false" x-small >hide warning</v-btn>
    </v-col>

    <v-col cols="12"
        v-for="entry in logItems"
        :key="entry.id"
        :id="`entry-at-${entry.createdAt}`"
    >

        <UserEntry v-if="entry.entryType == 'user'" :entry="entry" />
        <ChallengeRollEntry v-if="entry.entryType == 'genericChallengeRoll'" :entry="entry" />
        <RollEntry v-if="entry.entryType == 'roll'" :entry="entry" />
        <MoveEntry v-if="entry.entryType == 'move'" :entry="entry" />
        <OracleEntry v-if="entry.entryType == 'oracle'" :entry="entry" />

      </v-col>
  </v-row>
</template>

<script>
  import {mapGetters} from 'vuex';
import UserEntry from '@/components/entry/UserEntry'
import ChallengeRollEntry from '@/components/entry/ChallengeRollEntry'
import RollEntry from '@/components/entry/RollEntry'
import MoveEntry from '@/components/entry/MoveEntry'
import OracleEntry from '@/components/entry/OracleEntry'

  export default {
    name: 'Log',
    created() {},
    components: { UserEntry, ChallengeRollEntry, RollEntry, MoveEntry, OracleEntry },
    computed: {
      ...mapGetters('log', ['logItems']),
    },
    watch: {
    },
    data() {
      return {
        warningShown: true,
      };
    },
    methods: {},
  };
</script>
